import React from 'react';

import { css } from '@emotion/core';
import { Flex } from '@rebass/emotion';
import Colors from '@theme/colors';

import { FormCheckbox } from './index';

interface Option {
  key: string;
  value: string;
}

interface FormCheckboxGroupProps {
  name: string;
  value: string;
  options: Option[];
  onChange: (e: { target: { value: string; checked: string; id: string } }) => void;
  onBlur: (e: { target: { value: string; checked: string; id: string } }) => void;
  setFieldValue: (name: string, value: string[]) => void;
  setFieldError: (name: string, value: string[]) => void;
}

const FormCheckboxGroup = ({ name, value, options, setFieldValue }: FormCheckboxGroupProps) => {
  const checkboxGroupValue = value || [];
  const valueArray = [...checkboxGroupValue];
  let transformedOptions: any[] = []; // TODO: define better types

  if (!options[0].key && !options[0].value) {
    transformedOptions = options.map((option) => {
      return { key: option, value: option };
    });
  } else {
    transformedOptions = options;
  }

  return (
    <Flex
      flexWrap="wrap"
      mt={4}
      css={css`
        color: ${Colors.neutral75};
        opacity: 0.6;
      `}
    >
      {transformedOptions.map((option, index) => {
        return (
          <FormCheckbox
            key={option.key}
            name={name}
            // value can be null or empty
            value={value && value.length > 0 ? value.includes(option.value) : null}
            onChange={(e: { target: { value: string; checked: string; id: string } }) => {
              const target = e.target;
              if (target.checked) {
                valueArray.push(option.value);
              } else {
                valueArray.splice(valueArray.indexOf(option.value), 1);
              }
              setFieldValue(name, valueArray);
            }}
            id={`${name}-${index}`}
            label={option.key}
          />
        );
      })}
    </Flex>
  );
};

export { FormCheckboxGroup };
